@if (fieldDef.meta?.value_hidden) {
  <mat-form-field class="flex-auto w-full gt-xs:pr-3 contact-wrapper">
    <mat-label>{{ fieldDef.label }}</mat-label>
    <input #inputControl matInput [(ngModel)]="displayValue" disabled class="blurred" />
  </mat-form-field>
} @else {
  <ng-container
    *ngIf="
      customObjType === 'Company' || customObjType === 'Contact' || customObjType === 'Property' || customObjType === 'Project' || isCustomObjectLookup
    "
  >
    <mat-form-field
      TsFieldStyling
      [fieldBackgroundColor]="fieldStyling().color"
      [fieldBold]="fieldStyling().is_bold"
      [targetStylingClass]="commonTargetStylingClass"
      targetTextClass=".mat-select-value"
      class="flex-auto w-full gt-xs:pr-3 contact-wrapper"
    >
      <mat-label>{{ fieldDef.label }}</mat-label>
      <input
        style="display: none"
        [ngClass]="{ 'text-gray-default': readonly }"
        #inputControl
        matInput
        [ngModel]="value | readableField: model : fieldDef : []"
        (ngModelChange)="value = $event"
        [disabled]="isDisabled"
      />

      <button
        *ngIf="!!value && !isMultipleField && !isReadOnly"
        matSuffix
        mat-icon-button
        [matMenuTriggerFor]="menu"
        matTooltip="More actions"
        [matTooltipDisabled]="isDisabled"
        [disabled]="isDisabled"
      >
        <mat-icon>more_vert</mat-icon>
      </button>

      <mat-menu #menu="matMenu">
        <button
          *ngIf="!!value && isFilterable()"
          mat-menu-item
          [routerLink]="['/properties']"
          [queryParams]="{ filter: filterQueryParams() }"
        >
          <mat-icon [svgIcon]="'search'"></mat-icon>
          <span>Filter</span>
        </button>
        <ng-container *ngIf="value && !isDisabled">
          <button mat-menu-item (click)="removeModelField($event)">
            <mat-icon>cancel</mat-icon>
            <span>Remove</span>
          </button>
        </ng-container>
      </mat-menu>

      <div class="flex flex-row justify-between items-center w-full" [matTooltip]="showTip">
        <span class="underline pointer" (click)="value && !isDisabled && goToRecord()" *ngIf="!isMultipleField">
          {{ value }}
        </span>

        <ng-container
          *ngIf="isMultipleField"
          [ngTemplateOutlet]="multipleRecordList"
          [ngTemplateOutletContext]="{ value: value }"
        ></ng-container>

        <ng-container *ngIf="canShowAssociationButton()">
          <button
            [class.always-visible]="isMultipleField"
            class="mr-2 associate-btn"
            type="button"
            mat-icon-button
            (click)="openTypeRelatedModal()"
            [disabled]="readonly"
          >
            <mat-icon [svgIcon]="'add_box'"></mat-icon>
          </button>
        </ng-container>
      </div>
    </mat-form-field>
  </ng-container>

  <ng-container *ngIf="customObjType === 'User'">
    <mat-form-field
      TsFieldStyling
      [fieldBackgroundColor]="fieldStyling().color"
      [fieldBold]="fieldStyling().is_bold"
      [targetStylingClass]="commonTargetStylingClass"
      targetTextClass=".mat-select-value"
      class="flex-auto w-full gt-xs:pr-3"
      (click)="edit()"
      (focus)="edit()"
    >
      <mat-label>{{ fieldDef.label }}</mat-label>
      <div [matTooltip]="showTip" class="w-full">
        <mat-select
          [multiple]="isMultipleField"
          [ngClass]="{ readonly: isReadOnly }"
          (selectionChange)="onSelectionChange($event)"
          [ngModel]="multipleUserIds || value"
          (ngModelChange)="multipleUserIds || (value = $event)"
          (blur)="onBlur($event)"
          [disabled]="isDisabled || isReadOnly"
          [compareWith]="compareWithNull"
        >
          <mat-option [value]="NONE_VALUE">-- None --</mat-option>
          <mat-option *ngFor="let option of filteredOptions" [value]="option.id" [disabled]="!option?.active">{{
            option?.name || option?.full_name
          }}</mat-option>
        </mat-select>
      </div>
    </mat-form-field>
  </ng-container>

  <ng-container *ngIf="customObjType === 'FileResource'">
    <mat-form-field
      TsFieldStyling
      [fieldBackgroundColor]="fieldStyling().color"
      [fieldBold]="fieldStyling().is_bold"
      [targetStylingClass]="commonTargetStylingClass"
      class="flex-auto w-full gt-xs:pr-3 contact-wrapper"
    >
      <mat-label>{{ fieldDef.label }}</mat-label>
      <input style="display: none" matInput />
      <div [matTooltip]="showTip" class="flex flex-row justify-between items-center w-full" *ngIf="!uploadingFile">
        <span class="file-resource-label" *ngIf="!value"> Upload a file... </span>
        <span class="w-40 underline truncate pointer" (click)="viewFile(fileResource)" *ngIf="!isMultipleField">
          {{ value | readableField: model : fieldDef : [] }}
        </span>

        <ng-container
          *ngIf="isMultipleField"
          [ngTemplateOutlet]="multipleRecordList"
          [ngTemplateOutletContext]="{ value: value }"
        ></ng-container>

        <ng-container *ngIf="!value || isMultipleField">
          <button
            [class.always-visible]="isMultipleField"
            class="mr-2 add-file-btn"
            type="button"
            mat-icon-button
            (click)="addFileInput.click()"
            [disabled]="readonly"
          >
            <mat-icon [svgIcon]="'add_box'"></mat-icon>
            <input style="display: none" type="file" (change)="onFileChanged($event)" #addFileInput [accept]="acceptAttribute" />
          </button>
        </ng-container>

        <ng-container *ngIf="!isMultipleField && !!value">
          <button matSuffix mat-icon-button [matMenuTriggerFor]="menu" matTooltip="More actions">
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #menu="matMenu">
            <button mat-menu-item *ngIf="value && !isDisabled" (click)="downloadFile(fileResource)">
              <mat-icon [svgIcon]="'get_app'"></mat-icon>
              <span>Download</span>
            </button>

            <button mat-menu-item (click)="editFileInput.click()">
              <mat-icon>edit</mat-icon>
              <input style="display: none" type="file" (change)="onFileChanged($event)" #editFileInput [accept]="acceptAttribute" />
              <span>Edit</span>
            </button>

            <button mat-menu-item (click)="removeModelField($event)" *ngIf="value && !isDisabled">
              <mat-icon>cancel</mat-icon>
              <span>Remove</span>
            </button>
          </mat-menu>
        </ng-container>
      </div>
      <mat-progress-bar *ngIf="uploadingFile" mode="indeterminate"></mat-progress-bar>
      <mat-hint class="pb-1" *ngIf="hasImageRecordFormat">Supported formats: {{ imageRecordFormats.join(', ') }}</mat-hint>
    </mat-form-field>
  </ng-container>

  <ng-container *ngIf="customObjType === 'Engagement'">
    <mat-form-field
      TsFieldStyling
      [fieldBackgroundColor]="fieldStyling().color"
      [fieldBold]="fieldStyling().is_bold"
      [targetStylingClass]="commonTargetStylingClass"
      class="flex-auto w-full gt-xs:pr-3 contact-wrapper"
    >
      <mat-label>{{ fieldDef.label }}</mat-label>
      <input style="display: none" #inputControl matInput [ngModel]="value" (ngModelChange)="value = $event" />
      <div [matTooltip]="showTip" class="flex flex-row items-center w-full" *ngIf="value">
        @if (value) {
          {{ value?.engagement_type }} on {{ value?.event_date | date: 'MMM dd, y' }}
        }
      </div>
    </mat-form-field>
  </ng-container>

  <ng-container *ngIf="hasNoRecordType()">
    <mat-form-field
      TsFieldStyling
      [fieldBackgroundColor]="fieldStyling().color"
      [fieldBold]="fieldStyling().is_bold"
      [targetStylingClass]="commonTargetStylingClass"
      class="flex-auto w-full gt-xs:pr-3 contact-wrapper"
    >
      <mat-label>{{ fieldDef.label }}</mat-label>
      <input style="display: none" #inputControl matInput [ngModel]="value" (ngModelChange)="value = $event" />
      <div [matTooltip]="showTip" class="flex flex-row items-center w-full" *ngIf="value">
        <task-status [task]="value" [taskStatuses]="workflowStates" (onUpdate)="updateTask(value)"></task-status>
        <a (click)="goToRecord()">
          <div class="flex flex-col">
            <span class="font-semibold leading-none">{{ value.title }}</span>
            <span class="mt-1 text-sm leading-none text-secondary">
              <span *ngIf="value.due_date">{{ value.due_date | date: 'LLL dd, y' }}</span>
              <span *ngIf="value.assigned_user_name">• {{ value.assigned_user_name }}</span>
            </span>
          </div>
        </a>
      </div>
    </mat-form-field>
  </ng-container>

  <!-- RECORD MULTIPLE INPUT -->
  <ng-template let-value="value" #multipleRecordList>
    <mat-chip-list #chipList class="my-3">
      <mat-chip
        *ngFor="let item of value"
        [removable]="!isReadOnly"
        (removed)="removeItem(item)"
        (click)="goToRecord(item)"
      >
        {{ item.split('|')[1] }}
        <mat-icon matChipRemove>cancel</mat-icon>
      </mat-chip>
    </mat-chip-list>
  </ng-template>
}
